/**
 * @generated SignedSource<<f714dec7cfea381da423f9eba7746bf8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProviderFinishUploadMutation$variables = {
  datasetVersionId: string;
};
export type ProviderFinishUploadMutation$data = {
  readonly finishDatasetVersionUpload: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionCardFragment" | "DatasetVersionTableFragment" | "DatasetVersionTableRecordsFragment">;
  };
};
export type ProviderFinishUploadMutation = {
  response: ProviderFinishUploadMutation$data;
  variables: ProviderFinishUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "datasetVersionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "datasetVersionId",
    "variableName": "datasetVersionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProviderFinishUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DatasetVersion",
        "kind": "LinkedField",
        "name": "finishDatasetVersionUpload",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatasetVersionTableFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatasetVersionTableRecordsFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DatasetVersionCardFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ProviderFinishUploadMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DatasetVersion",
        "kind": "LinkedField",
        "name": "finishDatasetVersionUpload",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "schema",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rows",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": "viewerCanCreateDatasetVersion",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "CREATE_DATASET_VERSION"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"CREATE_DATASET_VERSION\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dataset",
            "kind": "LinkedField",
            "name": "dataset",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isEntity"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "displayName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "imageThumbnail",
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 10
              },
              {
                "kind": "Literal",
                "name": "offset",
                "value": 0
              }
            ],
            "kind": "ScalarField",
            "name": "records",
            "storageKey": "records(limit:10,offset:0)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "size",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publishable",
            "storageKey": null
          },
          {
            "alias": "viewerCanPublishDatasetVersion",
            "args": [
              {
                "kind": "Literal",
                "name": "action",
                "value": "PUBLISH_DATASET_VERSION"
              }
            ],
            "kind": "ScalarField",
            "name": "viewerCan",
            "storageKey": "viewerCan(action:\"PUBLISH_DATASET_VERSION\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e0d4269906fbe7c9578bf2e772ad6982",
    "id": null,
    "metadata": {},
    "name": "ProviderFinishUploadMutation",
    "operationKind": "mutation",
    "text": "mutation ProviderFinishUploadMutation(\n  $datasetVersionId: ID!\n) {\n  finishDatasetVersionUpload(datasetVersionId: $datasetVersionId) {\n    id\n    ...DatasetVersionTableFragment\n    ...DatasetVersionTableRecordsFragment\n    ...DatasetVersionCardFragment\n  }\n}\n\nfragment DatasetVersionCardFragment on DatasetVersion {\n  id\n  version\n  size\n  publishedAt\n  createdAt\n  updatedAt\n  dataset {\n    id\n    slug\n    owner {\n      __typename\n      username\n      ...EntityProfilePicFragment_49kWkb\n      id\n    }\n  }\n  ...DatasetVersionPublishButtonFragment\n}\n\nfragment DatasetVersionEditFileFragment on DatasetVersion {\n  id\n  version\n  viewerCanCreateDatasetVersion: viewerCan(action: CREATE_DATASET_VERSION)\n  dataset {\n    slug\n    id\n  }\n}\n\nfragment DatasetVersionPublishButtonFragment on DatasetVersion {\n  id\n  version\n  publishable @ifAllowed\n  viewerCanPublishDatasetVersion: viewerCan(action: PUBLISH_DATASET_VERSION)\n}\n\nfragment DatasetVersionTableFragment on DatasetVersion {\n  id\n  schema\n  rows\n  ...DatasetVersionEditFileFragment\n}\n\nfragment DatasetVersionTableRecordsFragment on DatasetVersion {\n  id\n  records(limit: 10, offset: 0)\n}\n\nfragment EntityProfilePicFragment_49kWkb on Entity {\n  __isEntity: __typename\n  displayName\n  imageThumbnail\n}\n"
  }
};
})();

(node as any).hash = "bca8e445d866c9e7ca6abb29ff21fc97";

export default node;
